// extracted by mini-css-extract-plugin
module.exports = {"resultItem":"ValueCard_resultItem__1RCXW","resultItemTitle":"ValueCard_resultItemTitle__1-h6A","amountNumber":"ValueCard_amountNumber__2nnIK","loader":"ValueCard_loader__2ZH_K"};